const theme = {
  fonts: {
    primary: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  },
  sizes: {
    borderRadius: '4px',
  },
  palette: {
    links: ['#1268CB', 'red'],
    success: ['#acb44e', '#4183C4'],
    paid: ['#45494D'],
    legend: ['#725CA4', '#06AEE7', '#FFA307', '#0E60B7'],
    visitsChart: [
      '#F5F3F8',
      '#E3DEED',
      '#C7BFDA',
      '#AA9EC7',
      '#8E7EB4',
      '#715EA2',
    ],
    republishChart: [
      '#E5F0FA',
      '#C7E0F6',
      '#A3D1F7',
      '#6BAEE8',
      '#2C8ADF',
      '#0E60B7',
    ],
    borders: [
      '#d1d1d1',
      '#f4f4f4',
      '#EED3D7',
      '#eaeaea',
      '#F5EDC8',
      '#e3e4eb',
      '#a9d5de',
    ],
    text: ['#333', '#bb4b4b', '#66512C', '#276f86'],
    backgrounds: ['#F8EEEF', '#FCF8E3', '#f2f8ff', '#f8ffff'],
  },
};

export default theme;
